// src/components/Hero.jsx
import React, { useEffect } from 'react';
import { useTranslation } from '../context/TranslationContext';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';

export default function Hero() {
  const { t } = useTranslation();
  useEffect(() => {
    $('.hero-slider').slick({ dots: true, infinite: true, autoplay: true, arrows: false, speed: 500 });
  }, []);

  return (
    <section id="hero" className="h-screen bg-cover bg-center flex items-center justify-center relative hero-section">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-indigo-900 opacity-60"></div>
        <div className="text-center text-white z-10 animate-fade-in">
            <h1 className="text-5xl md:text-6xl font-bold mb-4">{t('hero_title')}</h1>
            <div className="space-x-4">
                <a href="#quienes-somos" className="bg-indigo-900 text-white px-6 py-3 rounded hover:bg-cyan-500 transition-colors" aria-label="Descubre más sobre Qyntix">{t('hero_more_info')}</a>
                <a href="#contacto" className="border border-white text-white px-6 py-3 rounded hover:bg-white hover:text-indigo-900 transition-colors" aria-label="Contáctanos en Qyntix">{t('hero_contact')}</a>
            </div>
        </div>
    </section>
  );
}
